// 商机详情重构
export default {
  // 基础详情
  globalLoading: false,
  basicBizoppInfo: {},
  bizoppButtonGroup: {},
  signFailedReasonList: {},
  allBizoppInfo: {},
  tipCurRef: [],
  businessInfo: {}, // 经营信息需要单独获取
  surveyInfo: {}, // 门店调研信息单独获取
  curTabLabel: '',
  backoutApply: false,
  type: '',
  showPicker: false,
  isAIGray: null, // 是否命中灰度
  grayLoading: true,
  aiSummary: {}, // AI总结信息
}
